export default __webpack_public_path__ + "static/media/Wound of Sorrow.fb1c2dad.png";